import png from '@/public/assets/images/png.png'
import defalutImg from '@/public/assets/images/defalutImg.png'
import excel from '@/public/assets/images/excel.png'
import pdf from '@/public/assets/images/pdf.png'
import ppt from '@/public/assets/images/ppt.png'
import word from '@/public/assets/images/word.png'
import zip from '@/public/assets/images/zip.png'
import mp3 from '@/public/assets/images/mp3.png'
import mp4 from '@/public/assets/images/mp4.png'
import html from '@/public/assets/images/html.png'
import txt from '@/public/assets/images/txt.png'

const imgSuffixMaps = {
  png,
  jpeg: png,
  webp: png,
  defalutImg,
  excel,
  pdf,
  ppt,
  word,
  zip,
  mp3,
  html,
  jpg: png,
  xlsx: excel,
  docx: word,
  gif: png,
  mp4,
  xls: excel,
  pptx: ppt,
  txt
}

export function getImgSuffix(suffix) {
  return imgSuffixMaps[suffix] || imgSuffixMaps.defalutImg
}

export function getExtendName(name) {
  return (name && name.substring(name.lastIndexOf('.') + 1).toLowerCase()) || ''
}




// WEBPACK FOOTER //
// ./src/public/components/kye-preview/component/utils.js